import {changeBusyAction, setAlarmPasswordPopupScreenAction} from "../store/ui/actions"
import {useDispatch} from "react-redux"
import {useCallback} from "react"
import {isPromise} from "../utils/promise"
export function useApproving() {
    const dispatch = useDispatch()

    return useCallback(
        (
            yesCallback?: () => void,
            noCallback?: () => void,
            positive_button?: {text: string; timed: boolean},
            showCancel?: boolean
        ) => {
            dispatch(
                setAlarmPasswordPopupScreenAction(
                    true,
                    isApproved => {
                        if (isApproved) {
                            if (yesCallback) {
                                const output = yesCallback()
                                if (isPromise(output)) {
                                    dispatch(changeBusyAction(true))
                                    ;(output as unknown as Promise<unknown>).finally(() => {
                                        dispatch(changeBusyAction(false))
                                    })
                                }
                            }
                        } else {
                            if (noCallback) {
                                const output = noCallback()
                                if (isPromise(output)) {
                                    dispatch(changeBusyAction(true))
                                    ;(output as unknown as Promise<unknown>).finally(() => {
                                        dispatch(changeBusyAction(false))
                                    })
                                }
                            }
                        }
                    },
                    false,
                    positive_button,
                    showCancel
                )
            )
        },
        [dispatch]
    )
}
